module.exports = __webpack_public_path__ + "static/media/product_640-1.a9a0ec64.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/products/product_640-1.jpg
// module id = 2384
// module chunks = 0